export default __webpack_public_path__ + "static/commmune-community-marketing-9c1bf24696d25145617d5702ce618a26.png";